module.exports = __webpack_public_path__ + "img/company-value.05cdd1aa.jpg";